import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CalendarComponent } from './calendar.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { UseFunctionPipe } from '~backoffice/app/~shared/pipes/use-function.pipe';
import { TimeRangePipe } from '~backoffice/app/~shared/pipes/time-range.pipe';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';
import { DateService } from '~core/services/date.service';
import { MatIconModule } from '@angular/material/icon';
import { AngularSvgIconModule } from 'angular-svg-icon';

const DECLARATIONS = [CalendarComponent, CalendarHeaderComponent];

@NgModule({
  declarations: DECLARATIONS,
  imports: [
    CommonModule,
    MatDatepickerModule,
    NgScrollbarModule,
    UseFunctionPipe,
    TimeRangePipe,
    MatIconModule,
    AngularSvgIconModule
  ],
  providers: [DateService],
  exports: DECLARATIONS
})
export class CalendarModule {}
